<template>
    <div
        ref="group"
        :class="{ 'opacity-50 pointer-events-none': !isEnabledStep }"
        class="transition-all duration-200 ease-in"
    >
        <div class="hidden md:!flex md:flex-col">
            <option-group-name
                :group-index="groupIndex"
                :group-name="groupData.name"
            />

            <p class="mb-2 text-xs">
                {{ descriptionCopy }}
            </p>
        </div>

        <div class="flex md:flex-wrap gap-2">
            <div
                v-for="(option, index) in filteredOptions"
                :key="option"
                :class="{ 'pr-3.5 md:pr-0' : index + 1 === filteredOptions.length }"
            >
                <option-group-button
                    :option-data="option"
                    :group-name="groupData.name"
                    :is-enabled="isEnabledStep"
                    class="flex-shrink-0"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import OptionGroupName from './OptionGroupName.vue';
    import OptionGroupButton from './OptionGroupButton.vue';

    export default {
        mixins: [allStores],

        components: {
            OptionGroupName,
            OptionGroupButton,
        },

        props: {
            groupData: {
                type: Object,
                required: true,
            },

            groupIndex: {
                type: Number,
                required: true,
            },
        },

        computed: {
            isEnabledStep() {
                return this.appStore.isEnabledStep(this.groupData.name);
            },

            filteredOptions() {
                return this.groupData.placements[0].components.filter((component) => !component.placeholder);
            },

            descriptionCopy() {
                return this.groupData?.placements?.[0].description;
            },

            currentStep() {
                return this.appStore.currentStep;
            },
        },

        watch: {
            currentStep() {
                if (this.isCurrentStep()) {
                    // console.log('scroll into view');
                    this.$refs.group.scrollIntoView(true);
                }
            },
        },

        methods: {
            isCurrentStep() {
                return this.currentStep.includes(this.groupData.name);
            },
        },
    };
</script>
